// src/components/shared/SignedUrl.tsx
import { ReactNode } from 'react';
import { useSignedStorageUrl } from '@/lib/hooks/useSignedStorageUrl';

interface SignedUrlProps {
  /** URL storage salvato in DB (pubblico o firmato). */
  url: string | null | undefined;
  /** TTL del signed URL in secondi (default 12h). */
  ttlSeconds?: number;
  /**
   * Render-prop: riceve l'URL firmato fresco (o l'originale per i link esterni,
   * o `null` finché non risolto) e ritorna l'elemento da mostrare
   * (`<a href>`, `<img src>`, un player audio, ecc.).
   */
  children: (signedUrl: string | null) => ReactNode;
}

/**
 * Wrapper riutilizzabile per mostrare un file di uno storage privato: firma
 * l'URL salvato al momento dell'apertura. Usabile anche dentro un `.map()`
 * (a differenza del hook), un'istanza per allegato.
 *
 * Esempio:
 *   <SignedUrl url={att.url}>{(href) => <a href={href ?? undefined}>apri</a>}</SignedUrl>
 */
export function SignedUrl({ url, ttlSeconds, children }: SignedUrlProps) {
  const signed = useSignedStorageUrl(url, ttlSeconds);
  return <>{children(signed)}</>;
}
